import { RuleDataRequest } from 'runtime/data/ruledatarequest';

export class RuleDataUpdate extends RuleDataRequest {
    static $type = 'Web.RuleDataUpdate';

    value: any;
}